import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import { onMounted, reactive } from "vue";
import axiosInstance from "@/utils/axiosInstance";
import { useRouter } from "vue-router";
import { useOAuthStore } from "@/stores/oauth";
import { useUserInfoStore } from "@/stores/userInfo";



export default /*@__PURE__*/_defineComponent({
  __name: 'OAuthGithub',
  setup(__props) {

const router = useRouter();
const authStore = useOAuthStore();
const userInfoStore = useUserInfoStore();

const pagestate = reactive({
  backcode: "",
  token: "",
});

onMounted(async () => {
  // 获取 code 参数
  const code = router.currentRoute.value.query.code as string;
  GitHubCallBack(code);
});

//github authorization callback
const GitHubCallBack = (code: string) => {
  axiosInstance
    .get("api/OAuthGithub/GithubCallback", {
      params: {
        code: code,
      },
    })
    .then((res) => {
      var result = res.data;
      if (result.success) {
        authStore.setToken(result.data.token);
        GetUserInfo(result.data.token);
      }
    });
};

// get userinfo by token
const GetUserInfo = (token: string) => {
  axiosInstance
    .get("api/UserInfo/GetUserInfoByToken", {
      params: {
        token: token
      },
    })
    .then((res) => {
      var result = res.data;
      pagestate.token = result.data;
      if (result.success) {
        userInfoStore.setUser(result.data);
        const redirectUrl = localStorage.getItem('OAUTH_LOGIN_URL') || '/';
        localStorage.removeItem('OAUTH_LOGIN_URL');
        router.push(redirectUrl);
      }
    });
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", null, _toDisplayString(pagestate.backcode), 1),
    _createElementVNode("div", null, _toDisplayString(pagestate.token), 1)
  ], 64))
}
}

})